export default "__VITE_ASSET__CRI5ibRg__"